import React from 'react'
import { Props_SnippetHeading} from './Heading.props'

const SnippetHeading = (props: Props_SnippetHeading) => {
    const snippetid = props.snippet?.snippetid?.value ?  props.snippet.snippetid.value : '';
    const position = props.snippet?.position?.value ? ' snippet-heading--' + props.snippet.position.value : '';
   const padding = props.snippet?.padding?.value === "yes" ? ' snippet-heading--padding' : '';
   
    return (
        <section className={'snippet-heading' + position + padding} id={snippetid}>
            {props.snippet?.level?.value &&
                React.createElement(
                    props.snippet.level.value,
                    { className: 'snippet-heading__heading' },
                    props.snippet?.heading?.value
                )
            }
        </section>
    );
}

export default SnippetHeading